import React, { Component } from 'react';
import Measure from 'react-measure'
import { connect } from 'react-redux'
import close from "./images/close.png"
import point from "./images/point.png"
import comment from "./images/comment.png"
import {activePost} from "./actions/user";
import {interactPost} from './actions/posts';
import history from './history'
import './PostBox.css'
import {formatContent} from "./utils";

class PostBox extends Component {
  state={width: 0, height: 0}
  render() {
    let offset = 10
    let self = this
    let {hidden, width, height} = this.state
    let {interactPost, post, x, y, totalWidth, totalHeight, randomX, randomY, currentActivePost, activePost} = this.props
    x = x < offset + width/2? offset*(1+randomX) + width/2 : x
    x = x < totalWidth - width/2 - offset ? x : totalWidth - width/2  - offset*(1+randomX)
    y = y < height/2 + offset + 50 ? offset*(1+randomY) + height/2 + 50: y
    y = y < height/2 + totalHeight - offset - 40 ? y : totalHeight - height/2 - offset*(1+randomY) - 40
    return  <Measure
      bounds
      onResize={contentRect => {
        this.setState({ ...contentRect.bounds })
      }}
    >
      {({ measureRef }) => (
        <div
          ref={measureRef}
          className={`post-box-container ${currentActivePost===post._id?'post-box-container-active':''}`}
          style={{
            top: y ,
            left: x ,
            display: hidden?'none':'block',
          }}
          onClick ={()=>{
            if(currentActivePost === post._id){
              history.push('/posts/'+post._id)
            }else{
              activePost(post._id)
            }
            interactPost(post._id)
          }}
        >
          <div
            className={"post-box-header"}
          >
            <span
              className={"post-box-head-image"}
              style={{
                backgroundImage: !post.anonymous && `url(${post.user.headImgUrl})`
              }}
              onClick={(e)=>{
                if(currentActivePost === post._id && !post.anonymous){
                  if(window.location.pathname !== '/users/'+post.user._id){
                    e.preventDefault()
                    e.stopPropagation()
                    history.push('/users/'+post.user._id)
                  }
                }else{
                  activePost(post._id)
                }
              }}
            ></span>
            <span
              className={"post-box-nickname"}
              onClick={(e)=>{
                if(currentActivePost === post._id && !post.anonymous){
                  if(window.location.pathname !== '/users/'+post.user._id){
                    e.preventDefault()
                    e.stopPropagation()
                    history.push('/users/'+post.user._id)
                  }
                }else{
                  activePost(post._id)
                }
              }}
            >
              {post.anonymous?'匿名':post.user.nickname}
            </span>
          </div>
          <div className={"post-box-content"}>
            {formatContent(post.content.length<100?post.content:post.content.slice(0,100)+'...')}
          </div>
          <div className={"post-box-footer"}>
            <span className={"post-box-point"} style={{
              backgroundImage: `url(${point})`
            }}>{post.rewards || 0}</span>
            <span className={"post-box-comment"} style={{
              backgroundImage: `url(${comment})`
            }}>{post.commentsCount || 0}</span>
          </div>
          <div className={"post-box-close"} style={{
            backgroundImage: `url(${close})`
          }} onClick={(e)=>{
            e.preventDefault()
            e.stopPropagation()
            self.setState({hidden: true})
          }}>
          </div>
        </div>
      )}
    </Measure>
  }

}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    activePost: (_id)=>dispatch(activePost(_id)),
    interactPost: (_id)=>dispatch(interactPost(_id))
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentActivePost: state.user.activePost
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PostBox)




// WEBPACK FOOTER //
// ./src/PostBox.js